/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Outdoor_HouseInputs */

const cs_enum_outdoor_house = /** @type {(inputs: Enum_Outdoor_HouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exteriér domu`)
};

const en_enum_outdoor_house = /** @type {(inputs: Enum_Outdoor_HouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`House exterior`)
};

/**
* | output |
* | --- |
* | "House exterior" |
*
* @param {Enum_Outdoor_HouseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_outdoor_house = /** @type {((inputs?: Enum_Outdoor_HouseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Outdoor_HouseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_outdoor_house(inputs)
	return cs_enum_outdoor_house(inputs)
});